import Image from '../../common/Image/Image';
import { TBackground, addBackground } from '../../core/helpers';
import { IImage } from '../../core/models';
import './ImageSection.css';

interface IProps {
  img: IImage;
  full: boolean;
  size?: 'large' | 'medium' | 'small';
  background?: TBackground;
}

function ImageSection({ img, full, size, background }: IProps) {
  return (
    <section
      className={`image-section${background ? ' section-bg' : ' section'}`}
      {...addBackground({ img: undefined, gradient: background })}
    >
      <div className="wrap wrap--lg">
        <div className="image-section__container">
          <Image
            className={`image-section__img${full ? ' image-section__img--full' : ''}`}
            img={img}
            size={size}
          />
        </div>
      </div>
    </section>
  );
}

export default ImageSection;
